import React from 'react';
import { Helmet } from 'react-helmet';

import Navbar from './menu/Navbar';
import './App.scss';
import s from './Layout.module.scss';
import favIcon from '../../static/favicon.ico';
import { YoastMeta } from '../types';
import { rewriteToInternal } from '../libs/utils/misc';

interface Props {
  children: React.ReactNode;
  yoastMeta: YoastMeta;
  siteMeta: {
    name: string;
    description: string;
  };
  disableBackground?: boolean;
  disableNavigation?: boolean;
}

const Layout = ({
  children,
  yoastMeta,
  siteMeta,
  disableBackground,
  disableNavigation,
}: Props) => {
  const ogImage =
    yoastMeta &&
    yoastMeta.yoast_wpseo_facebook_image &&
    yoastMeta.yoast_wpseo_facebook_image.source_url &&
    yoastMeta.yoast_wpseo_facebook_image.source_url.replace(
      'https://',
      'http://'
    );
  const ogImageSecure =
    yoastMeta &&
    yoastMeta.yoast_wpseo_facebook_image &&
    yoastMeta.yoast_wpseo_facebook_image.source_url;

  return (
    <div
      className={`${s.wrapper} ${disableBackground ? s.disableBackground : ''}`}
    >
      <Helmet>
        <title>
          {siteMeta ? siteMeta.name : ''} |{' '}
          {siteMeta ? siteMeta.description : ''}
        </title>
        <link
          href="https://fonts.googleapis.com/icon?family=Material+Icons"
          rel="stylesheet"
        />
        <meta
          name="description"
          content={yoastMeta && yoastMeta.yoast_wpseo_metadesc}
        />
        <link
          rel="canonical"
          href={
            yoastMeta &&
            yoastMeta.yoast_wpseo_canonical &&
            rewriteToInternal(yoastMeta.yoast_wpseo_canonical)
          }
        />
        <link rel="shortcut icon" type="image/png" href={favIcon} />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={yoastMeta && yoastMeta.yoast_wpseo_title}
        />
        <meta
          property="og:description"
          content={yoastMeta && yoastMeta.yoast_wpseo_metadesc}
        />
        <meta
          property="og:url"
          content={
            yoastMeta &&
            yoastMeta.yoast_wpseo_canonical &&
            rewriteToInternal(yoastMeta.yoast_wpseo_canonical)
          }
        />
        <meta
          property="og:site_name"
          content={yoastMeta && yoastMeta.yoast_wpseo_title}
        />
        <meta property="og:image" content={ogImage} />
        <meta property="og:image:secure_url" content={ogImageSecure} />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      {!disableNavigation && <Navbar />}
      <div id={'innerbody'}>{children}</div>
    </div>
  );
};

export default Layout;
